// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--mHL5q","tabs":"e2ff468f85--tabs--oLbVw","tab":"e2ff468f85--tab--gRQnE","footer":"e2ff468f85--footer--Cv1HH"};